import type { ConversationMessage } from '@atlassian/unified-help-common/src/types';

export const getTotalRequestForms = (message: ConversationMessage): number => {
	return message?.appendices?.filter((appendix) => appendix.type === 'requestForm')?.length ?? 0;
};
